// - Sequence Numbers
//
const AUDIT_SERVICE_NAME = 'audit'

export default {
    namespaced: true,
    actions: {
        list({ dispatch }, { after, target }) {
            return new Promise(function (resolve, reject) {
                let query = ''
                if (after) {
                    query = '?after=' + encodeURIComponent(after)
                }
                if (target) {
                    if(after) {
                        query += '&'
                    } else {
                        query = '?'
                    }
                    query = query + 'target=' + encodeURIComponent(target)
                }
                return dispatch('API', AUDIT_SERVICE_NAME, { root: true })
                    .then(api => api.get('/' + query))
                    .then(response => resolve(response.data))
                    .catch(err => reject(err))
            })
        },
    }
}